import client from './client';
import { _createAlert } from './apiUtils';

export interface GenerateDailyPayrollReportRequest {
    payPeriodID: number;
    emailTo: string[];
}

export interface GenerateDailyPayrollReportResponse {
    success: boolean;
    message?: string;
}

// Function to generate the Daily Payroll Report v2
export const generateDailyPayrollReport = async (
    payPeriodID: number,
    emailTo: string[]
): Promise<GenerateDailyPayrollReportResponse> => {
    try {
        // Make the API request to generate the daily payroll report
        const response = await client.post('/admin/report/daily/payPeriod', {
            payPeriodID: payPeriodID,
            emailTo: emailTo
        });

        // Log the response data to the console
        console.log('Daily Payroll Report generation response:', response.data);

        // Return the response data
        return response.data || { success: true };

    } catch (error: any) {
        // Log any errors that occur during the report generation
        console.error('Error generating daily payroll report:', error);
        
        // Extract error message from response if available
        const errorMessage = error.response?.data?.message || error.message || 'Unknown error occurred';
        
        // Trigger an alert with the error message
        _createAlert('Error generating report:', errorMessage);
        
        // Return error response
        return { success: false, message: errorMessage };
    }
};
